import React, { useContext, useEffect, useState } from 'react'
import Context from '../../context'

import BankHelper from '../../helpers/BankCodes'
import SearchBankModal from './Components/SearchBankModal'

function BankAccountForm() {
  const { formObject, setFormObject, bankInfo, setBankInfo, clubPercent, setClubPercent } =
    useContext(Context)

  const [openModal, setOpenModal] = useState(false)

  useEffect(() => {
    if (bankInfo.value !== '' && bankInfo.label === '') {
      setBankInfo(BankHelper.bankCodes.find(item => item.value === bankInfo.value))
    }
  })

  useEffect(() => {
    setFormObject({ ...formObject, bankCode: bankInfo.value })
  }, [bankInfo, formObject.bankCode])

  useEffect(() => {
    console.log('clubPercent', clubPercent)
    if (!!clubPercent && 100 - clubPercent !== formObject.partnerPercent) {
      setFormObject(data => {
        return { ...data, partnerPercent: 100 - clubPercent }
      })
    }
  }, [clubPercent])

  const handleBankInput = () => {
    setOpenModal(true)
  }

  return (
    <>
      <h5>Dados Bancários</h5>

      <div className="form-row">
        <div
          className="form-check form-group align-items-center col-6"
          style={{ paddingLeft: '40px' }}
        >
          <input
            checked={formObject.hasInAppPurchase}
            onChange={() =>
              setFormObject({
                ...formObject,
                hasInAppPurchase: !formObject.hasInAppPurchase
              })
            }
            className="form-check-input"
            type="checkbox"
            id="hasInAppPurchase"
          />
          <label htmlFor="hasInAppPurchase" className="form-check-label">
            Possui vendas no app do Clube
          </label>
        </div>
      </div>

      {formObject.hasInAppPurchase && (
        <div className="form-row">
          {(formObject.contactEmail === null || formObject.contactEmail === '') && (
            <div className="alert alert-danger col-12" role="alert">
              O campo de e-mail nos contatos não pode ser vazio.
            </div>
          )}
          <div className="form-group col-6">
            <label htmlFor="accountNumber">Número da Conta</label>
            <div className="input-group">
              <input
                value={formObject.accountNumber || ''}
                onChange={e =>
                  setFormObject({
                    ...formObject,
                    accountNumber: `${e.target.value}`
                  })
                }
                type="number"
                className="form-control"
                placeholder="Número da Conta"
                id="accountNumber"
              />
            </div>
          </div>
          <div className="form-group col-6">
            <label htmlFor="accountVerificationCode">Dígito</label>
            <div className="input-group">
              <input
                value={formObject.accountVerificationCode || ''}
                onChange={e =>
                  setFormObject({
                    ...formObject,
                    accountVerificationCode: `${e.target.value}`
                  })
                }
                type="number"
                className="form-control"
                placeholder="Dígito"
                id="accountVerificationCode"
              />
            </div>
          </div>
          <div className="form-group col-6">
            <label htmlFor="branchCode">Agência</label>
            <div className="input-group">
              <input
                value={formObject.branchCode || ''}
                onChange={e =>
                  setFormObject({
                    ...formObject,
                    branchCode: `${e.target.value}`
                  })
                }
                type="number"
                className="form-control"
                placeholder="Agência"
                id="branchCode"
              />
            </div>
          </div>
          <div className="form-group col-6">
            <label htmlFor="accountType">Tipo da Conta</label>
            <select
              className="form-control"
              id="accountType"
              value={`${formObject.accountType}`}
              onChange={e =>
                setFormObject({
                  ...formObject,
                  accountType: Number(e.target.value)
                })
              }
            >
              <option selected value="1">
                Corrente
              </option>
              <option value="2">Poupança</option>
            </select>
          </div>
          <div className="form-group col-6">
            <label htmlFor="bankName">Banco</label>
            <div className="input-group">
              <input
                value={bankInfo.label}
                onChange={e => setBankInfo({ ...bankInfo, label: `${e.target.value}` })}
                type="text"
                className="form-control"
                placeholder="Banco"
                id="bankName"
              />
            </div>
          </div>
          <div className="form-group col-5">
            <label htmlFor="bankCode">Código do Banco</label>
            <div className="input-group">
              <input
                value={bankInfo.value}
                onChange={e => setBankInfo({ ...bankInfo, value: `${e.target.value}` })}
                type="number"
                className="form-control"
                placeholder="Código do Banco"
                id="Código do Banco"
              />
            </div>
          </div>
          <div className="form-group d-flex flex-column-reverse col-1">
            <button type="button" className="btn btn-primary" onClick={handleBankInput}>
              Procurar
            </button>
          </div>
          <div className="form-group col-6">
            <label htmlFor="clubTax">Taxa do Clube em %</label>
            <div className="input-group">
              <input
                value={clubPercent}
                step=".1"
                onChange={e => setClubPercent(parseFloat(e.target.value))}
                type="number"
                className="form-control"
                id="clubTax"
                placeholder="Taxa do Clube"
              />
              <div className="input-group-append">
                <span className="input-group-text">%</span>
              </div>
            </div>
          </div>
        </div>
      )}
      <Context.Provider value={{ bankInfo, setBankInfo, openModal, setOpenModal }}>
        <SearchBankModal />
      </Context.Provider>
    </>
  )
}

export default BankAccountForm
